import BriefGrid from './CreativeBriefs.BriefGrid';
import BriefPanelContainer from './CreativeBriefs.BriefPanel.Container';
import FilterSidebar from './CreativeBriefs.FilterSidebar';
import type {
  CBFilterHandlers,
  CBFilterOptions,
  CBFilterState,
  CreativeBriefResponse,
  ToggleVisibilityFn
} from './CreativeBriefs.types';
import { LeftSidebar, MainContent, PageLayout } from './styles/layout.styles';

type CreativeBriefsViewProps = {
  filterState: CBFilterState;
  filterOptions: CBFilterOptions;
  handlers: CBFilterHandlers;
  briefs: CreativeBriefResponse[];
  total: number;
  loading: boolean;
  onToggleVisibility: ToggleVisibilityFn;
  updatingBriefIds: Set<string>;
  selectedBrief: CreativeBriefResponse | null;
  isPanelOpen: boolean;
  onPanelClose: () => void;
  onBriefClick: (brief: CreativeBriefResponse) => void;
};

const CreativeBriefsView = ({
  filterState,
  filterOptions,
  handlers,
  briefs,
  total,
  loading,
  onToggleVisibility,
  updatingBriefIds,
  selectedBrief,
  isPanelOpen,
  onPanelClose,
  onBriefClick
}: CreativeBriefsViewProps) => (
  <>
    <PageLayout>
      <LeftSidebar>
        <FilterSidebar
          filterState={filterState}
          filterOptions={filterOptions}
          handlers={handlers}
        />
      </LeftSidebar>
      <MainContent>
        <BriefGrid
          briefs={briefs}
          total={total}
          pageSize={filterState.pageSize}
          currentPage={filterState.pageNumber}
          setCurrentPage={handlers.setPage}
          loading={loading}
          onToggleVisibility={onToggleVisibility}
          updatingBriefIds={updatingBriefIds}
          onBriefClick={onBriefClick}
        />
      </MainContent>
    </PageLayout>
    <BriefPanelContainer brief={selectedBrief} isOpen={isPanelOpen} onClose={onPanelClose} />
  </>
);

export default CreativeBriefsView;
